export default __webpack_public_path__ + "static/media/thumb_Cn.b8ac3823.jpg";